import { useEffect, useState } from "react";

const getConnectionType = () => {
  const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  return conn?.effectiveType || "unknown";
};

export default function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [connectionType, setConnectionType] = useState(getConnectionType());

  useEffect(() => {
    const updateStatus = () => {
      setIsOnline(navigator.onLine);
      setConnectionType(getConnectionType());
    };

    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);

    const conn = navigator.connection;
    if (conn) conn.addEventListener("change", updateStatus);

    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
      if (conn) conn.removeEventListener("change", updateStatus);
    };
  }, []);

  return { isOnline, connectionType };
}